export default "__VITE_ASSET__CCXAV$ME__"